module.exports = {
  config: {
    footerText: 'Copyright Company Name © 2018',
    aesKey: '5T7y9O3u7H2j5K9L3z2W5x9Q1p6R4v8M',
    aesIV: '37fa77f6a3b0462d',

    //本地测试
    // baseUrl: 'https://localhost:7227/api', //API访问地址
    // clientUrl: 'https://localhost:3001', //client访问地址
    // staffUrl: 'https://localhost:3000', //staff访问地址
    // recaptchaSitekey: '6Ld3d4wcAAAAAIlKmNgvDxznIXZ61_7IItYqdZ2S', //google人机验证的key

    //生产环境
    baseUrl: 'https://client-api.hyperflo.net/api', //API访问地址
    clientUrl: 'https://client.hyperflo.net', //client访问地址
    staffUrl: 'https://app.hyperflo.net', //staff访问地址
    recaptchaSitekey: '6LdYPk4dAAAAAGeK_BXKJOH4UIPeDSUxQZu7yXD_', //google人机验证的key

    format: {
      date: 'DD/MM/YYYY', //格式化时间格式
      sqlDate: 'YYYY-MM-DD'
    },
    taxRate: 0.1,
    setTimeoutMilliSecond: 10,
    //组件相关
    component: {
      size: 'middle', //组件尺寸 large | middle | small
      gutter: [0, 8], //栅格间隔
      margin: 'normal',
      bordered: true, //组件是否有边框
      defaultDeleteConfirmText: 'Do you want to delete this record?', //删除数据时默认的提示文字
      Input: {
        Textarea: {
          rows: 5, //文本域默认行数
        }
      },
      DatePicker: {
        dateFormat: 'DD/MM/YYYY', //日期控件默认格式
      },
      Pagination: {
        pageSize: 20, //默认一页行数
        pageSizeOptions: [20, 50, 100], //设置页码可选项
        showSizeChanger: true, //是否可以改变 pageSize
        showTotal: total => `${total} records total`, //显示总条数
      },
      AutoComplete: {
        minimumQueryCharacters: 2, //最少多少个字符时触发查询自动完成的数据
      },
      Message: {
        style: {
          marginTop: '20vh',
        },
      },
      Modal: {
        maskClosable: false, //点击背景遮罩是否关闭
      },
      Empty: {
        imageStyle: {
          height: 40,
        },
        description: 'No Data'
      },
      Icon: {
        style: {
          fontSize: '18px'
        },
      },
      Image: {
        //加载失败的默认图片
        fallback: "data:image/png;base64,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"
      },
      Table: {
        // scroll: { x: 'max-content' }
        scroll: null,
        fixed: null
      },
      Tooltip: {
        mouseEnterDelay: 0.6
      },
      Button: {
        size: 'middle',
      },
      ColorPicker: {
        defaultColor: '#03a9f4',
      },
      CKEditor: {
        config: {
          toolbar: ['fontSize', 'fontColor', 'bold', 'italic', 'underline', 'strikethrough', 'bulletedList', 'numberedList', 'link', 'undo', 'redo',],
          fontSize: {
            options: [12, 14, 'default', 18, 20, 24, 30, 36, 48],
            supportAllValues: true,
          },
        }
      }
    },
    defaultCountry: 'Australia', //默认国家
    states: ['VIC', 'NSW', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'], //州列表
    imageTypes: ['image/jpeg', 'image/png', 'image/bmp'], //图片格式
    uploadImageMaxLength: 600, //上传图片最大尺寸(大于这个值的会被压缩到这个值), KB
    fileUploadLimit: 100, //上传文件最大尺寸(大于这个值的不让上传), MB
    addressFinderKey: 'TERV3X4J6UFKPD7QMCHA',
    psmaKey: 'dWeaHO6dr2ngCyustDJ7bLAir7mAfOpD',
    googleMap: {
      apiKey: 'AIzaSyDfIkiuIbtSPWEhU2qsDqOELne0_slNaNU',
      defaultCenter: {
        lat: -37.768,
        lng: 145.006
      },
      defaultZoom: 11,
      markerStyle: { fontSize: '30px', color: 'red' } //地图上打点的样式
    },
    message: {
      sessionExpired: 'Your session has expired, please login again.' //账户被禁用等情况下, 需要重新登陆的信息
    },
    pattern: {
      email: new RegExp(/^((\s*|\s*,\s*)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*))*$/g, 'i'), //验证电子邮件的正则
      password: new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/, 'i') // 验证密码
    },
    sms: {
      mobileStartWith: ['04', '+614']
    },
    color: {
      default: '#03a9f4',
      success: '#28a745',
      danger: '#dc3545',
      inactive: '#6c757d',
    },
    fontColor: '#495057',
    emailRecipient: [{
      value: 'Applicant',
      label: 'Applicant',
    }, {
      value: 'Owner',
      label: 'Owner',
    }, {
      value: 'Builder',
      label: 'Builder',
    }, {
      value: 'Client',
      label: 'Client',
    }, {
      value: 'Council',
      label: 'Council',
    }, {
      value: 'AssignedUser',
      label: 'Assigned User',
    }, {
      value: 'AssessingUser',
      label: 'Assessing User',
    }, {
      value: 'SignoffUser',
      label: 'Signoff User',
    }]
  }
}
